export default "/assets/images/chart-03.svg?565026da6b4bcd3cb8ed3233497fea7c";